function updateBundleButton() {
  var hasItem = false;
  var total = 0;

  $('.bundle-products-item').each(function() {
    var qty = parseInt($(this).find('input[name="quantity"]').val());
    if (qty > 0) {
      hasItem = true;
      total = total + qty;
    }
  });

  // Progress bar logic
  var maxSteps = 5;
  var width = (total / maxSteps) * 100;
  width = Math.min(width, 95);

  $('.bundle-progress-bar-active').css('width', width + '%');
  $('[class^="step-"]').removeClass('active');

  for (var i = 1; i <= total && i <= maxSteps; i++) {
    $('.step-' + i + ' .step-label').addClass('active');
  }

  console.log('total', total, 'width', width + '%');

  var price = parseFloat($('.custom-selling-plan').data('price')) / 100;
  var purchaseType = $('.selling-plan-title input[type="radio"]:checked').val();
  var pr_discount_sub = 0;
  var pr_discount = price;

  if (total === 1) {
    pr_discount_sub = price * .9;
  } else if (total === 2) {
    pr_discount_sub = price * .85;
    pr_discount = price * .9;
  } else if (total === 3) {
    pr_discount_sub = price * .8;
    pr_discount = price * .85;
  } else if (total === 4) {
    pr_discount_sub = price * .75;
    pr_discount = price * .8;
  } else if (total >= 5) {
    pr_discount_sub = price * .7;
    pr_discount = price * .75;
  }
  if (total >= 1) {
    $('.selling-plan-price.subscription').html('<s>$'+price.toFixed(2)+'</s>$'+pr_discount_sub.toFixed(2)+'/bag');
    $('.selling-plan-price.one-time').html('<s>$'+price.toFixed(2)+'</s>$'+pr_discount.toFixed(2)+'/bag');
  }
  if (total < 1) {
    $('.selling-plan-price.one-time').html(price.toFixed(2)+'/bag');
  }
  if (total == 0) {
    $('.selling-plan-price.subscription').html(price.toFixed(2)+'/bag');
  }

  if (hasItem) {
    if (purchaseType == 'subscription') {
      $('.btn-add-custom-all').html('$'+(pr_discount_sub*total).toFixed(2)+'<span id="add_text">Add to cart</span>');
    } else {
      $('.btn-add-custom-all').html('$'+(pr_discount*total).toFixed(2)+'<span id="add_text">Add to cart</span>');
    }
  } else {
    $('.btn-add-custom-all').text('Select at least 1 bag');
  }
  $('.btn-add-custom-all').prop('disabled', !hasItem);
}

$('body').on('click', '.add-to-bundle', function(){
    $(this).hide();
    $(this).next().show();
    $(this).next().find('input[name="quantity"]').val(1);

    updateBundleButton();
});

$('body').on('click', '.minus-bundle', function(){   
    const qty = parseInt($(this).next().val());
    const new_qty = qty - 1;
    if (new_qty < 1) {
        $(this).parent().hide();
        $(this).parent().prev().show();
        $(this).next().val(new_qty);
    } else {
        $(this).next().val(new_qty);
    }

    updateBundleButton();
});

$('body').on('click', '.plus-bundle', function(){
    const qty = parseInt($(this).prev().val());
    const new_qty = qty + 1;
      
    $(this).prev().val(new_qty);

    updateBundleButton();
});

$('body').on('change', '.selling-plan-title input[type="radio"]', function(){
  const val = $(this).val();

  $('.subscription-wrapper').removeClass('active');
  $('.bundle-progress').removeClass('active');
  if (val == 'onetime') {
    $('.bundle-progress.one-time').addClass('active');
    $('.subscription-wrapper-onetime').addClass('active');
  } else {
    $('.bundle-progress.subscription').addClass('active');
    $('.subscription-wrapper-autoship').addClass('active');
  }

  updateBundleButton();
  
});


$(document).on('click', '.btn-add-custom-all', function(e) {
  e.preventDefault();

  var discountCode = '';
  var total_c = 0;
  $('.bundle-products-item').each(function() {
    var qty = parseInt($(this).find('input[name="quantity"]').val()) || 0;
    if (qty > 0) {
      total_c += qty;
    }
  });
  // Assign discount code
  // if (total_c === 2) {
  //   discountCode = 'BUILDBUNDLE10';
  // } else if (total_c === 3) {
  //   discountCode = 'BUILDBUNDLE15';
  // } else if (total_c === 4) {
  //   discountCode = 'BUILDBUNDLE20';
  // } else if (total_c >= 5) {
  //   discountCode = 'BUILDBUNDLE25';
  // } else {
  //   discountCode = ''; // remove if total is 1 or 0
  // }

  var items = [];

  $('.bundle-products-item').each(function() {
    var variantId = $(this).data('variant-id');
    var quantity = parseInt($(this).find('input[name="quantity"]').val());
    var sellingPlanId = $(this).data('selling-plan-id'); 

    // Get selected purchase type
    var purchaseType = $('.selling-plan-title input[type="radio"]:checked').val();
    console.log('purchaseType', purchaseType);

    if (quantity && quantity > 0) {
      var item = {
        id: variantId,
        quantity: quantity
      };

      // Only add selling_plan if subscription is selected
      if (purchaseType === 'subscription' && sellingPlanId) {
       item.selling_plan = sellingPlanId;
      }

      items.push(item);
    }
  });

  if (items.length === 0) {
    //alert('Please select at least one product.');
    return;
  }

  // Step 1: Add items
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { items: items },
    dataType: 'json',
    success: function() {

      // Step 2: Apply discount
      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/update.js',
      //   data: {
      //     discount: discountCode // '' removes discount
      //   },
      //   dataType: 'json',
      //   success: function(cart) {
      //     console.log('Cart updated with discount:', discountCode, cart);

      //     // Optional: update UI or open cart drawer
      //   },
      //   error: function(err) {
      //     console.error('Discount apply failed', err);
      //   }
      // });

    },
    error: function(err) {
      console.error('Add to cart failed', err);
    }
  });
});
